import { SubmissionError } from 'redux-form'

import lang from '../lang/validation.json'

export async function handleResponseErrors(response) {
  console.debug(response)
  if (response.data && response.data.errors) {
    return processServerErrors(response.data.errors)
  }

  if (response.status === 410) {
    throw new SubmissionError({ _error: lang.gone })
  }

  throw new SubmissionError({ _error: lang.unknown })
}

export default function processServerErrors(errors) {
  throw new SubmissionError(errors.reduce((out, e) => {
    const field = e.field || '_error'
    if (!out[field]) {
      out[field] = []
    }
    out[field].push(e.message)
    return out
  }, {}))
}